"use client";
import React, { useState } from "react";
import { FaPlay, FaEnvelope, FaWhatsapp } from "react-icons/fa";
import { IoClose } from "react-icons/io5";

const Documentary = ({ onClose }) => {
  const [showVideo, setShowVideo] = useState(false);
  const [showReferralModal, setShowReferralModal] = useState(false);

  const handleVideoOpen = () => setShowVideo(true);
  const handleVideoClose = () => setShowVideo(false);

  const handleReferralOpen = () => setShowReferralModal(true);
  const handleReferralClose = () => setShowReferralModal(false);

  return (
    <>
      {/* ============================== REFERRAL MODAL ============================== */}
      {showReferralModal && (
        <div className="fixed inset-0 z-[60] bg-black/70 backdrop-blur-sm flex items-center justify-center px-4">
          <div
            className="
              relative w-full max-w-xl 
              bg-white/10 backdrop-blur-2xl 
              border border-white/20 
              rounded-3xl shadow-2xl p-8 
              overflow-y-auto max-h-[90vh] 
              animate-fadeIn
            "
          >
            {" "}
            {/* Floating Glow */}
            <div className="absolute -top-10 -left-10 w-40 h-40 bg-primary_red/20 rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 right-0 w-32 h-32 bg-white/20 rounded-full blur-2xl"></div>
            {/* Close Button */}
            <button
              onClick={handleReferralClose}
              className="absolute -top-0 -right-0 bg-red-600 text-white p-2 rounded-full shadow hover:bg-red-700 transition"
            >
              <IoClose size={22} />
            </button>
            {/* BEAUTIFUL HEADER WITH ILLUSTRATION */}
            <div className="flex flex-col items-center text-center">
              {/* BEAUTIFUL BUILT-IN MEDICAL ILLUSTRATION (NO IMPORT REQUIRED) */}
              <div className="w-40 mx-auto mb-3 opacity-90">
                <svg
                  width="100%"
                  viewBox="0 0 200 200"
                  xmlns="http://www.w3.org/2000/svg"
                  className="drop-shadow-lg"
                >
                  <circle cx="100" cy="100" r="80" fill="#ffdde1" />
                  <circle cx="70" cy="85" r="22" fill="#ffffff" />
                  <circle cx="130" cy="85" r="22" fill="#ffffff" />
                  <rect
                    x="55"
                    y="110"
                    width="90"
                    height="50"
                    rx="15"
                    fill="#ffffff"
                  />
                  <rect
                    x="85"
                    y="95"
                    width="30"
                    height="10"
                    rx="3"
                    fill="#ff4d67"
                  />
                  <circle cx="70" cy="85" r="10" fill="#ff4d67" />
                  <circle cx="130" cy="85" r="10" fill="#ff4d67" />
                </svg>
              </div>

              <h3 className="text-2xl md:text-3xl font-extrabold text-white tracking-tight mb-2">
                Partner With Our BMT Referral Programme
              </h3>

              <p className="text-gray-200 text-[16px] max-w-md leading-relaxed">
                Join our mission to save lives through early intervention,
                timely access to Bone Marrow Transplantation, and coordinated
                patient support across healthcare facilities.
              </p>
            </div>
            {/* CONTENT SECTION */}
            <div className="mt-6 text-gray-100 space-y-4 text-[15.5px] leading-relaxed">
              <p>
                ✓ Are you a doctor, nurse, or healthcare provider who wants to
                refer patients?
              </p>
              <p>✓ Does your hospital want to partner with our BMT Centre?</p>
              <p>
                ✓ Would you like to sponsor or financially support a patient’s
                transplant journey?
              </p>

              <p className="mt-4 text-gray-200 italic">
                We're ready to collaborate with hospitals, NGOs, donors, and
                individuals to help more patients access life-saving BMT
                procedures.
              </p>

              {/* CONTACT CARDS */}
              <div className="mt-6 p-5 rounded-2xl bg-white/10 border border-white/20 shadow-inner space-y-5">
                <div className="flex items-start gap-3">
                  <FaEnvelope className="text-primary_red mt-1" />
                  <p>
                    <span className="font-semibold text-white">Email:</span>
                    <br />
                    partnerships@sicklecellfoundation.com
                    <br />
                    caudu@sicklecellfoundation.com
                  </p>
                </div>

                <div className="flex items-start gap-3">
                  <FaWhatsapp className="text-green-400 mt-1" />
                  <p>
                    <span className="font-semibold text-white">
                      WhatsApp / Call:
                    </span>
                    <br />
                    0806 969 2327
                    <br />
                    0913 957 6794
                  </p>
                </div>

                <p className="text-[14px] text-gray-300">
                  Response time: within 24 hours • Dedicated partnership team
                  available
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ============================== VIDEO MODAL ============================== */}
      {showVideo ? (
        <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center px-4">
          <div className="relative w-full md:w-[80%] lg:w-[70%] aspect-video">
            {/* Close Button */}
            <button
              className="absolute -top-14 right-0 modern-btn-red"
              onClick={handleVideoClose}
            >
              Close
            </button>

            {/* Referral Button */}
            <button
              onClick={handleReferralOpen}
              className="absolute -top-14 left-0 modern-btn-primary"
            >
              Join Referral Programme
            </button>

            <iframe
              className="w-full h-full rounded-2xl shadow-xl"
              // src="https://www.youtube.com/embed/jju8uJV6HEs?start=9&autoplay=1&mute=1"
              src="https://drive.google.com/file/d/1rh9WUC1XgkMMegxLOOIwHtgCAj1DNFh1/preview"
              title="Bone Marrow Transplant Documentary"
              allowFullScreen
            />
          </div>
        </div>
      ) : (
        /* ============================== HERO IMAGE SECTION ============================== */
        <section
          style={{
            backgroundImage: "url(/assets/bmt/bmt_documentary.jpg)",
          }}
          className="relative w-full h-[60vh] md:h-[50vh] lg:h-[90vh] 
          flex items-center justify-center rounded-1xl overflow-hidden shadow-xl 
          transition-all bg-cover bg-center"
        >
          {/* Dark overlay */}
          <div className="absolute inset-0 bg-black/40"></div>

          <div className="relative flex flex-col items-center justify-center text-center">
            {/* Play button */}
            <button
              onClick={handleVideoOpen}
              className="h-20 w-20 rounded-full bg-primary_red flex items-center justify-center 
              shadow-xl hover:scale-110 transition cursor-pointer"
            >
              <FaPlay className="text-white text-3xl" />
            </button>

            {/* <h2 className="mt-6 text-3xl md:text-4xl lg:text-5xl font-extrabold text-white tracking-tight drop-shadow-xl max-w-2xl">
              Bone Marrow Transplant Now in Nigeria
            </h2> */}

            <h2 className="mt-6 text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight tracking-tight">
              <span
                className="block text-transparent bg-clip-text bg-gradient-to-r 
    from-white via-gray-200 to-blue-300"
              >
                Bone Marrow Transplant
              </span>

              <span
                className="block text-transparent bg-clip-text bg-gradient-to-r 
    from-white via-gray-200 to-teal-300"
              >
                Now in Nigeria
              </span>
            </h2>

            {/* Buttons row */}
            <div className="flex items-center gap-5 mt-8">
              <button onClick={onClose} className="modern-btn-red">
                Close
              </button>

              <button
                onClick={handleReferralOpen}
                className="modern-btn-primary"
              >
                Join Referral Programme
              </button>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Documentary;
